import _regeneratorRuntime from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.function.name";
// import { Message } from "element-ui"
import { login as _login, logout as _logout, getInfo as _getInfo } from "@/api/login";
import { getApiAuthories } from "@/api/apiAuthority";
import { getToken, removeToken, removeTokenTwo, setToken, removeAppId, setAppId, setAvatar, setPersonName, removeAvatar, removePersonName } from "@/utils/auth";
// import { encrypt } from "@/utils/crypto"
import router, { resetRouter } from "@/router";
var state = {
  token: getToken(),
  name: "",
  avatar: "",
  introduction: "",
  roles: [],
  appId: "",
  apps: [],
  accessedMenu: []
};
var mutations = {
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_INTRODUCTION: function SET_INTRODUCTION(state, introduction) {
    state.introduction = introduction;
  },
  SET_NAME: function SET_NAME(state, name) {
    state.name = name;
  },
  SET_AVATAR: function SET_AVATAR(state, avatar) {
    state.avatar = avatar;
  },
  SET_ROLES: function SET_ROLES(state, roles) {
    state.roles = roles;
  },
  SET_APPS: function SET_APPS(state, apps) {
    state.apps = apps;
  },
  SET_APPID: function SET_APPID(state, appId) {
    state.appId = appId;
  },
  SET_ACCESSEDMENU: function SET_ACCESSEDMENU(state, menus) {
    state.accessedMenu = menus;
  }
};
var actions = {
  setTokenRoles: function setTokenRoles(_ref, data) {
    var commit = _ref.commit;
    return new Promise(function (resolve) {
      // const token = encrypt(data)
      var token = "Bearer " + data.token;
      commit("SET_TOKEN", token);
      // localStorage.setItem("SET_AVATAR", data.avatar)
      // localStorage.setItem("SET_NAME", data.personName)
      setAvatar(data.avatar);
      setPersonName(data.personName);
      commit("SET_AVATAR", data.avatar);
      commit("SET_NAME", data.personName);
      setToken(token);
      sessionStorage.setItem("USER_DATA", JSON.stringify({
        name: data.personName,
        loginTime: new Date().getTime()
      }));
      resolve();
    });
  },
  setApps: function setApps(_ref2, data) {
    var commit = _ref2.commit;
    return new Promise(function (resolve) {
      var currappId = data.filter(function (p) {
        return p.appCode === process.env.VUE_APP_APP_CODE;
      });
      commit("SET_APPID", currappId[0].id);
      commit("SET_APPS", data);
      setAppId(currappId[0].id);
      // localStorage.setItem("SET_APPID", data[0].id)
      sessionStorage.setItem("SET_APPS", JSON.stringify(data.apps));
      resolve();
    });
  },
  // user login
  login: function login(_ref3, userInfo) {
    var commit = _ref3.commit;
    var username = userInfo.username,
      password = userInfo.password;
    return new Promise(function (resolve, reject) {
      _login({
        username: username.trim(),
        password: password
      }).then(function (response) {
        var data = response.data;
        commit("SET_TOKEN", data.token);
        setToken(data.token);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // get user info
  getInfo: function getInfo(_ref4) {
    var commit = _ref4.commit,
      state = _ref4.state;
    return new Promise(function (resolve, reject) {
      _getInfo(state.token).then(function (response) {
        var data = response.data;
        if (!data) {
          reject("Verification failed, please Login again.");
        }
        var roles = data.roles,
          name = data.name,
          avatar = data.avatar,
          introduction = data.introduction;

        // roles must be a non-empty array
        if (!roles || roles.length <= 0) {
          reject("getInfo: roles must be a non-null array!");
        }
        commit("SET_ROLES", roles);
        commit("SET_NAME", name);
        commit("SET_AVATAR", avatar);
        commit("SET_INTRODUCTION", introduction);
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getMenus: function () {
    var _getMenus = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref5, appid) {
      var commit, state, res;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref5.commit, state = _ref5.state;
            _context.next = 3;
            return getApiAuthories(appid);
          case 3:
            res = _context.sent;
            commit("SET_MENUS", res.data);
            return _context.abrupt("return", res && res.data);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function getMenus(_x, _x2) {
      return _getMenus.apply(this, arguments);
    }
    return getMenus;
  }(),
  // user logout
  logout: function logout(_ref6) {
    var commit = _ref6.commit,
      dispatch = _ref6.dispatch,
      state = _ref6.state;
    return new Promise(function (resolve, reject) {
      // params:state.token
      _logout().then(function () {
        commit("SET_TOKEN", "");
        commit("SET_ACCESSEDMENU", []);
        commit("SET_ROLES", []);
        removeToken();
        removeTokenTwo();
        removeAppId();
        resetRouter();
        removeAvatar();
        removePersonName();
        sessionStorage.clear();
        // reset visited views and cached views
        // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
        dispatch("tagsView/delAllViews", null, {
          root: true
        });
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // user anthLogout
  anthLogout: function anthLogout(_ref7) {
    var commit = _ref7.commit,
      dispatch = _ref7.dispatch,
      state = _ref7.state;
    return new Promise(function (resolve, reject) {
      commit("SET_TOKEN", "");
      commit("SET_ACCESSEDMENU", []);
      commit("SET_ROLES", []);
      removeToken();
      removeTokenTwo();
      resetRouter();
      removeAppId();
      removeAvatar();
      removePersonName();
      sessionStorage.clear();
      localStorage.clear();
      dispatch("tagsView/delAllViews", null, {
        root: true
      });
      resolve();
    });
  },
  // remove token
  resetToken: function resetToken(_ref8) {
    var commit = _ref8.commit;
    return new Promise(function (resolve) {
      commit("SET_TOKEN", "");
      commit("SET_ACCESSEDMENU", []);
      commit("SET_ROLES", []);
      removeToken();
      removeTokenTwo();
      resolve();
    });
  },
  // dynamically modify permissions
  changeRoles: function changeRoles(_ref9, role) {
    var commit = _ref9.commit,
      dispatch = _ref9.dispatch;
    return new Promise( /*#__PURE__*/function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(resolve) {
        var token, _yield$dispatch, roles, accessRoutes;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              token = role + "-token";
              commit("SET_TOKEN", token);
              setToken(token);
              _context2.next = 5;
              return dispatch("getInfo");
            case 5:
              _yield$dispatch = _context2.sent;
              roles = _yield$dispatch.roles;
              resetRouter();

              // generate accessible routes map based on roles
              _context2.next = 10;
              return dispatch("permission/generateRoutes", roles, {
                root: true
              });
            case 10:
              accessRoutes = _context2.sent;
              // dynamically add accessible routes
              router.addRoutes(accessRoutes);

              // reset visited views and cached views
              dispatch("tagsView/delAllViews", null, {
                root: true
              });
              resolve();
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x3) {
        return _ref10.apply(this, arguments);
      };
    }());
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};